export default "__VITE_ASSET__e8a701b4__"